// Copyright (c) 2023 Visual Intelligence LP. All rights reserved.
//
import * as React from "react";
import { Divider, Grid, Typography } from '@mui/material';
import { withStyles } from "tss-react/mui";
import "./ConfirmationDialog.css";

import { CheckBoxSelection, ListBoxComponent, MultiSelect, MultiSelectComponent } from "@syncfusion/ej2-react-dropdowns";
import { DialogComponent } from "@syncfusion/ej2-react-popups";


MultiSelect.Inject(CheckBoxSelection);

// prop interface for the main class.
export interface ConfirmationDialogProps {
  className?: string;
  classes?: Record<string, any>;
  title: () => string;
  message: () => string;
  items: () => Array<string>;
  showDialog: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

/*
  Display the Confirmation dialog.
*/
class ConfirmationDialog extends React.Component<ConfirmationDialogProps> {
  // Refs to syncfusion components.

  constructor(props: ConfirmationDialogProps) {
    super(props);    
  }

  handleSubmit = (args: PointerEvent) => {
    const { onSubmit } = this.props;
    onSubmit();
  }

  // Set label and callback for dialog buttons.
  private buttonConfig() {
    const { items } = this.props;
    const hasItems = items().length > 0;
    const confirmBtn = {
      buttonModel: {
          content: hasItems ? 'Confirm' : 'OK',
          cssClass: 'e-flat',
          isPrimary: true,
      },
      'click': (args: PointerEvent) => {
        if (hasItems) {
          this.handleSubmit(args);
        }
        else {
          const { onClose } = this.props;
          onClose();
        }
      }
    };
    const cancelBtn = {
      buttonModel: {
        content: 'Cancel',
        cssClass: 'e-flat'
      },
      'click': () => {
        const { onClose } = this.props;
        onClose();
      }
    };
    return hasItems ?  [confirmBtn, cancelBtn] : [confirmBtn];
  }

  render() {
    const { title, message, items, showDialog, onClose } = this.props;
    const classes = withStyles.getClasses(this.props);
    // console.log("****** render ConfirmationDialog:", message());
    const showList = items().length > 0;
    const buttonModels = this.buttonConfig();

    return (
      <div className={classes.root}>
        <DialogComponent
          width={600}
          minHeight={showList ? 250 : 180}
          isModal={true}
          //overlayClick={this.onOverlayClick}
          header={title()}
          //showCloseIcon={true}
          visible={showDialog} 
          close={onClose}
          buttons={buttonModels}
        >
          <Divider variant="fullWidth" className={classes.divider} />

          <Grid container spacing={5}>
            <Grid item>
              <Typography variant="body2" className={showList ? classes.label : classes.text}>
                {message()}
              </Typography>
            </Grid>
            {showList && 
            <div className={classes.listbox}>
              <ListBoxComponent
                height={150}
                dataSource={items()}
              />
            </div>
            }
          </Grid>
        </DialogComponent>
      </div>
    )
  }
}

const ConfirmationDialogStyled = withStyles(
  ConfirmationDialog, 
  (theme, props) => ({
    "root": {
      paddingTop: theme.spacing(5)
    },

    "label": {
      margin: 0, 
      fontWeight: 'bold'
    },

    "text": {
      margin: 0, 
      fontWeight: 'normal'
    },

    "text_exclude": {
      margin: 0, 
      marginLeft: 10,
      fontWeight: 'normal'
    },

    "listbox": {
      width: '100%',
      paddingTop: theme.spacing(5),
      paddingLeft: theme.spacing(5),
    },

    "divider": {
      marginBottom: 10
    }
  })
);

export default ConfirmationDialogStyled;